import {
  SquaresFourIcon,
  BooksIcon,
  BookOpenIcon,
  BookBookmarkIcon,
  PlanetIcon,
  UsersIcon,
  MapTrifoldIcon,
  ShareNetworkIcon,
  FileTextIcon,
  SparkleIcon,
  QuestionIcon,
  GearIcon,
} from '@phosphor-icons/react';
import type { AppIcon } from '@/lib/icon';

export interface ModuleDef {
  path: string;
  label: string;
  icon: AppIcon;
  /** 어느 마일스톤에서 구현되는지 (placeholder 표시용) */
  milestone: string;
  group: 'main' | 'footer';
}

/** 좌측 내비 = 엔티티 모델의 뷰 (PRD §5 / 03 §4.1). SideNav·router·⌘K가 공유. Phosphor 아이콘. */
export const MODULES: ModuleDef[] = [
  { path: '/reading', label: '독서실', icon: BookOpenIcon, milestone: 'W-R1', group: 'main' },
  { path: '/library', label: '서재', icon: BookBookmarkIcon, milestone: 'W-R3', group: 'main' },
  { path: '/overview', label: '개요', icon: SquaresFourIcon, milestone: 'M3', group: 'main' },
  { path: '/codex', label: '캐논', icon: BooksIcon, milestone: 'M2', group: 'main' },
  { path: '/worlds', label: '세계관', icon: PlanetIcon, milestone: 'M3', group: 'main' },
  { path: '/characters', label: '인물 OS', icon: UsersIcon, milestone: 'M3', group: 'main' },
  { path: '/plot', label: '플롯', icon: MapTrifoldIcon, milestone: 'M4', group: 'main' },
  { path: '/graph', label: '관계도', icon: ShareNetworkIcon, milestone: 'M6', group: 'main' },
  { path: '/manuscript', label: '원고', icon: FileTextIcon, milestone: 'M8', group: 'main' },
  { path: '/concepts', label: '개념', icon: SparkleIcon, milestone: 'M3', group: 'main' },
  { path: '/questions', label: '미결정', icon: QuestionIcon, milestone: 'M3', group: 'main' },
  { path: '/settings', label: '설정', icon: GearIcon, milestone: 'M7', group: 'footer' },
];
